<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filterRequests"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            @click:row="openRequest"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="align-center py-4 mx-0"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col
                        cols="12"
                        class="d-flex pl-4 pl-sm-8 pl-md-2 pl-lg-3 pl-xl-3"
                    >
                        <v-row class="mx-4 d-flex align-center justify-center">
                            <v-btn-toggle
                                mandatory
                                borderless
                                :style="{ height: '36px' }"
                            >
                                <v-btn
                                    @change="setPMPurchases(false)"
                                    :style="{
                                        'font-size': '12px',
                                        height: '36px',
                                    }"
                                    class="px-1 py-1"
                                >
                                    {{
                                        user.permissions &&
                                        Array.isArray(user.permissions) &&
                                        user.permissions.includes(
                                            'allClosedPurchases'
                                        )
                                            ? 'All Purchases'
                                            : 'Created by Me'
                                    }}
                                </v-btn>
                                <v-btn
                                    @change="setPMPurchases(true)"
                                    :style="{
                                        'font-size': '12px',
                                        height: '36px',
                                    }"
                                    class="px-1 py-1"
                                >
                                    Project Manager
                                </v-btn>
                            </v-btn-toggle>
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateRangeText"
                                        label="Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :style="{
                                            'min-width': '230px',
                                            width: '230px',
                                            maxWidth: '230px',
                                        }"
                                        class="pt-3 ml-4"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="dates" range scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        :loading="loading"
                                        @click="loadData"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-spacer></v-spacer>
                            <v-btn
                                rounded
                                elevation="0"
                                color="primary"
                                class="text-center btnStatus white--text"
                                :disabled="loading"
                                @click="openFindPurchase()"
                            >
                                <v-icon> mdi-magnify</v-icon>
                                Find
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.number`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="idToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                    class="pt-2"
                />
            </template>

            <template v-slot:[`header.items`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="itemsToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.deliveryLocation`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="locationToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.date`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dateToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.dueDate`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dueDateToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.notes`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="notesToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.createdBy`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="usersToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.date`]="{ item }">
                <p class="my-0 text-capitalize">
                    {{ formatDate(item.createdOn._seconds) }}
                </p>
            </template>
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="my-0">
                    <div>
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{
                                        item.createdBy
                                            ? item.createdBy.name
                                            : ''
                                    }}
                                </p>
                            </template>
                            <span>Creator</span>
                        </v-tooltip>
                    </div>
                    <div v-if="item.projectManager">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{
                                        item.projectManager
                                            ? item.projectManager.name
                                            : ''
                                    }}
                                </p>
                            </template>
                            <span>Project Manager</span>
                        </v-tooltip>
                    </div>
                    <div v-if="item.buyer">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ getUser(item.buyer) }}
                                </p>
                            </template>
                            <span>Buyer</span>
                        </v-tooltip>
                    </div>
                </div>
            </template>
            <template v-slot:[`item.totalPrice`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ formatNumber(calculateTotal(item)) }}</p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <p class="my-0 text-capitalize">
                    {{ item.project ? item.project.name : '' }}
                </p>
            </template>
            <template v-slot:[`item.items`]="{ item }">
                <div>
                    <p
                        class="my-0"
                        v-for="(element, index) of item.items"
                        :key="index"
                    >
                        {{ element.description }} ({{ element.quantity }})
                    </p>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu rounded offset-y>
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn icon v-bind="attrs" v-on="on" small class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="openTimeLineDialog(item)">
                            <v-list-item-title>
                                Timeline
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <!--Request Form-->
        <v-dialog persistent fullscreen v-model="openForm">
            <PurchaseRequest
                v-if="openForm"
                :localRequest="selectedRequest"
                :originalRequest="originalRequest"
                :createForm="createForm"
                @closeDialog="closeRequestForm"
                @replaceRequest="replaceRequest"
                @closePurchase="closePurchase"
            />
        </v-dialog>
        <!--ALERT MESSAGES-->
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--Time Line-->
        <v-dialog v-model="openTimeLine" max-width="500">
            <TimeLinePurchase
                v-if="openTimeLine"
                :request="timeLineRequest"
                :users="users"
                @closeDialog="closeTimeLine"
            />
        </v-dialog>
        <!-- Find Purchase by Number -->
        <v-dialog
            v-model="findPurchase"
            :retain-focus="false"
            persistent
            max-width="600"
        >
            <FindPurchase
                v-if="findPurchase"
                @openRequest="openRequest"
                @close="findPurchase = false"
            />
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import { firestore } from '@/services/firebase'
import moment from 'moment'
import PurchaseRequest from '@/components/Purchasing/PurchaseRequest.vue'
import TimeLinePurchase from '@/components/Purchasing/TimeLinePurchase.vue'
import _ from 'lodash'
import API from '@/services/api'
import FindPurchase from './findPurchase.vue'

export default {
    name: 'PurchasingClosed',
    components: {
        PurchaseRequest,
        TimeLinePurchase,
        FindPurchase,
    },
    data: () => ({
        menu: false,
        dates: ['', ''],
        createForm: false,
        selectedRequest: {},
        originalRequest: {},
        rules: {
            number: v => {
                if (v === '' || v === null || v === undefined) return true
                if (isNaN(v)) return 'Must be a number'
                if (v <= 0) return 'Must be greater than 0'
                if (!Number.isInteger(Number(v)))
                    return 'Decimals are not allowed'
                return true
            },
        },
        openForm: false,
        activateAlert: false,
        alertMessage: '',
        loading: false,
        headers: [
            {
                text: 'ID',
                value: 'number',
                sortable: false,
                align: 'center',
                width: '100px',
            },
            {
                text: 'PROJECT',
                value: 'project',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ITEMS',
                value: 'items',
                sortable: false,
                align: 'left',
            },
            {
                text: 'TOTAL PRICE',
                value: 'totalPrice',
                sortable: false,
                align: 'center',
            },
            {
                text: 'USERS',
                value: 'createdBy',
                sortable: false,
                align: 'center',
            },
            {
                text: 'REQ DATE',
                value: 'date',
                sortable: false,
                align: 'center',
            },
            {
                text: 'DUE DATE',
                value: 'dueDate',
                sortable: false,
                align: 'center',
            },
            {
                text: 'DELIVERY AT',
                value: 'deliveryLocation',
                sortable: false,
                align: 'center',
            },
            {
                text: 'NOTES',
                value: 'notes',
                sortable: false,
                align: 'left',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
            },
        ],
        requests: [],
        projectToFilter: undefined,
        deliveryParamToFilter: undefined,
        dateToFilter: undefined,
        dueDateToFilter: undefined,
        notesToFilter: undefined,
        usersToFilter: undefined,
        locationToFilter: undefined,
        itemsToFilter: undefined,
        listener: null,
        companyId: JSON.parse(localStorage.getItem('company')),
        idToFilter: undefined,
        resourceId: undefined,
        user: {},
        openTimeLine: false,
        users: [],
        number: '',
        findPurchase: false,
        loadId: 0,
    }),
    computed: {
        ...mapState(['notificationResource']),
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
        filterRequests() {
            this.openResource()
            let conditions = []

            if (this.projectToFilter) {
                conditions.push(this.filterForProject)
            }

            if (this.itemsToFilter) {
                conditions.push(this.filterForItems)
            }

            if (this.deliveryParamToFilter) {
                conditions.push(this.filterForDeliveryAt)
            }

            if (this.idToFilter) {
                conditions.push(this.filterForId)
            }

            if (this.dateToFilter) {
                conditions.push(this.filterForDate)
            }

            if (this.dueDateToFilter) {
                conditions.push(this.filterForDueDate)
            }

            if (this.locationToFilter) {
                conditions.push(this.filterForLocation)
            }

            if (this.notesToFilter) {
                conditions.push(this.filterForNotes)
            }

            if (this.usersToFilter) {
                conditions.push(this.filterForUsers)
            }

            if (conditions.length > 0) {
                return this.requests.filter(request => {
                    return conditions.every(condition => {
                        return condition(request)
                    })
                })
            }
            this.sort()
            return this.requests
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.resourceId = this.$route.query.resourceId
            let currentDate = new Date()
            let date1 = new Date(currentDate)
            date1.setMonth(date1.getMonth() - 3)
            date1.setHours(0, 0, 0, 0)
            this.dates[0] = date1.toISOString().split('T')[0]
            this.dates[1] = currentDate.toISOString().split('T')[0]
            const [
                {
                    data: { users },
                },
                {
                    data: { user },
                },
            ] = await Promise.all([API.getLiteUsers(), API.getMyInfo()])
            this.users = users || []
            this.user = user || {}
            await this.loadData()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        async fetchAllClosedPages({
            initialDate,
            finishDate,
            projectManager,
            loadId,
        }) {
            const firstParams = { initialDate, finishDate }
            if (projectManager) {
                firstParams.projectManager = projectManager
            }
            let {
                purchases,
                jobId,
                pageToken,
            } = await API.getPurchasesClosedByDate(firstParams)
            let buffer = [...(purchases || [])]
            while (pageToken && loadId === this.loadId) {
                const next = await API.getPurchasesClosedNextPage({
                    jobId,
                    pageToken,
                })
                buffer = buffer.concat(next.purchases || [])
                pageToken = next.pageToken
            }
            if (loadId !== this.loadId) {
                return null
            }
            return buffer
        },
        async loadData() {
            const loadId = ++this.loadId
            this.loading = true
            this.requests = []
            try {
                let date1 = new Date(this.dates[0]).getTime()
                let date2 = new Date(this.dates[1]).getTime()
                if (date1 > date2) {
                    date1 = this.dates[1]
                    date2 = this.dates[0]
                } else {
                    date1 = this.dates[0]
                    date2 = this.dates[1]
                }
                const purchases = await this.fetchAllClosedPages({
                    initialDate: date1,
                    finishDate: date2,
                    loadId,
                })
                if (purchases) {
                    this.requests = purchases
                    this.sort()
                    this.refreshListener(date1, date2)
                    this.menu = false
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                if (loadId === this.loadId) {
                    this.loading = false
                }
            }
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE').format(
                Math.ceil(number != undefined ? number : 0)
            )
        },
        filterForId(item) {
            return item.number.toString().includes(this.idToFilter)
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        closePurchase() {
            const closedId = this.selectedRequest?.id
            if (closedId) {
                this.requests = this.requests.filter(r => r.id !== closedId)
            }
            this.alertMessage = 'Purchase was successfully Closed'
            this.activateAlert = true
            this.closeRequestForm()
        },
        filterForDeliveryAt(item) {
            return (
                item.deliveryAt &&
                item.deliveryAt
                    .toLowerCase()
                    .includes(this.deliveryParamToFilter.toLowerCase())
            )
        },
        filterForProject(item) {
            return (
                item.project &&
                item.project.name
                    .toLowerCase()
                    .includes(this.projectToFilter.toLowerCase())
            )
        },
        filterForItems(item) {
            return (
                item.itemsLabel &&
                item.itemsLabel
                    .toLowerCase()
                    .includes(this.itemsToFilter.toLowerCase())
            )
        },
        filterForDate(item) {
            const date = this.formatDate(
                item.createdOn.seconds
                    ? item.createdOn.seconds
                    : item.createdOn._seconds
            )
            return date.includes(this.dateToFilter)
        },
        filterForDueDate(item) {
            return item.dueDate.includes(this.dueDateToFilter)
        },
        filterForNotes(item) {
            return (
                item.notes &&
                item.notes
                    .toLowerCase()
                    .includes(this.notesToFilter.toLowerCase())
            )
        },
        filterForLocation(item) {
            return (
                item.deliveryLocation &&
                item.deliveryLocation
                    .toLowerCase()
                    .includes(this.locationToFilter.toLowerCase())
            )
        },
        filterForUsers(item) {
            return (
                (item.createdBy.name &&
                    item.createdBy.name
                        .toLowerCase()
                        .includes(this.usersToFilter.toLowerCase())) ||
                (item.projectManager.name &&
                    item.projectManager.name
                        .toLowerCase()
                        .includes(this.usersToFilter.toLowerCase())) ||
                (item.buyer &&
                this.users.find(user => user.id == item.buyer) != undefined
                    ? this.users
                          .find(user => user.id == item.buyer)
                          .name.toLowerCase()
                          .includes(this.usersToFilter.toLowerCase())
                    : false)
            )
        },
        getUser(id) {
            const user = this.users.find(u => u.id == id)
            if (user) {
                return user.name
            }
            return null
        },
        openRequest(request) {
            this.findPurchase = false
            this.originalRequest = _.cloneDeep(request)
            this.selectedRequest = _.cloneDeep(request)
            this.selectedRequest.items.forEach(item => {
                const foundQuote = (item.quotes || []).find(quote => quote.able)
                item.quotes = []
                if (foundQuote) {
                    item.quotes.push(foundQuote)
                }
            })
            this.openForm = true
        },
        openTimeLineDialog(request) {
            this.timeLineRequest = _.cloneDeep(request)
            this.openTimeLine = true
        },
        closeTimeLine() {
            this.openTimeLine = false
            this.timeLineRequest = {}
        },
        closeRequestForm() {
            this.openForm = false
            this.selectedRequest = {}
            this.originalRequest = {}
        },
        replaceRequest() {},
        sort() {
            this.requests.sort((a, b) => b.number - a.number)
        },
        openResource() {
            if (this.resourceId) {
                const resource = this.requests.find(
                    r => r.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openRequest(resource)
                }
            }
        },
        calculateTotal(request) {
            let calculatedTotal = 0
            request.items = request.items ? request.items : []
            request.items.forEach(i => {
                i.quotes = i.quotes ? i.quotes : []
                i.quotes.forEach(q => {
                    if (q.able) {
                        calculatedTotal +=
                            Number(i.quantity || 0) *
                            Number(q.priceBeforeTRM ?? q.price ?? 0)
                    }
                })
            })
            return calculatedTotal
        },
        async setPMPurchases(option) {
            const loadId = ++this.loadId
            this.loading = true
            this.requests = []
            try {
                let date1 = new Date(this.dates[0]).getTime()
                let date2 = new Date(this.dates[1]).getTime()
                if (date1 > date2) {
                    date1 = this.dates[1]
                    date2 = this.dates[0]
                } else {
                    date1 = this.dates[0]
                    date2 = this.dates[1]
                }
                const projectManager = option ? this.user.id : undefined
                const purchases = await this.fetchAllClosedPages({
                    initialDate: date1,
                    finishDate: date2,
                    projectManager,
                    loadId,
                })
                if (purchases) {
                    this.requests = purchases
                    this.sort()
                    this.refreshListener(date1, date2, projectManager)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                if (loadId === this.loadId) {
                    this.loading = false
                }
            }
        },
        async openFindPurchase() {
            this.findPurchase = true
        },
        async refreshListener(date1, date2, projectManager = undefined) {
            if (this.listener) {
                this.listener()
            }
            let PurchasesQuery = firestore
                .collection('companies')
                .doc(this.companyId)
                .collection('purchases')
                .where('status', '==', 'closed')
                .where('updatedOn', '>=', date1)
                .where('updatedOn', '<=', date2)

            this.listener = await PurchasesQuery.onSnapshot(
                async docSnapshot => {
                    docSnapshot.docChanges().forEach(async change => {
                        const request = Object.assign(change.doc.data(), {
                            id: change.doc.id,
                        })
                        if (request.items) {
                            request.items.forEach(item => {
                                request.itemsLabel = request.itemsLabel
                                    ? request.itemsLabel +
                                      `${item.description} ${
                                          item.purchaseOrder
                                              ? '(' +
                                                item.purchaseOrder.orderNumber +
                                                ')'
                                              : ''
                                      }`
                                    : `${item.description} ${
                                          item.purchaseOrder
                                              ? '(' +
                                                item.purchaseOrder.orderNumber +
                                                ')'
                                              : ''
                                      }`
                            })
                        }
                        if (change.type === 'added') {
                            request.dueDate = this.formatDate(
                                request.dueDate.seconds
                            )
                            this.requests.push(request)
                        }
                        if (change.type === 'modified') {
                            request.dueDate = this.formatDate(
                                request.dueDate.seconds
                            )
                            const index = this.requests.findIndex(
                                r => r.id == request.id
                            )
                            if (index >= 0) {
                                this.requests.splice(index, 1, request)
                            }
                        }
                        if (change.type === 'removed') {
                            const index = this.requests.findIndex(
                                r => r.id == request.id
                            )
                            if (index >= 0) {
                                this.requests.splice(index, 1)
                            }
                        }
                    })
                }
            )
            this.requests.forEach(request => {
                request.dueDate = this.formatDate(request.dueDate._seconds)
                request.createdBy = { id: request.createdBy }
                request.createdBy.name = this.users.find(
                    user => user.id == request.createdBy.id
                )?.name
                if (request.items) {
                    request.items.forEach(item => {
                        request.itemsLabel = request.itemsLabel
                            ? request.itemsLabel +
                              `${item.description} ${
                                  item.purchaseOrder
                                      ? '(' +
                                        item.purchaseOrder.orderNumber +
                                        ')'
                                      : ''
                              }`
                            : `${item.description} ${
                                  item.purchaseOrder
                                      ? '(' +
                                        item.purchaseOrder.orderNumber +
                                        ')'
                                      : ''
                              }`
                    })
                }
            })
            if (projectManager) {
                this.requests = this.requests.filter(
                    item =>
                        item.projectManager &&
                        item.projectManager.id &&
                        item.projectManager.id === projectManager
                )
            }
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 1;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
.v-data-table__wrapper {
    max-height: 72vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 64px;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
</style>
